<template>
  <div class="support-cultural-program">
    <div class="support-cultural-program-header">
      <div class="logo"></div>
      <div class="contact" v-if="theatre.SupportPhone">
        <div class="contact-label">Служба поддержки</div>
        <div class="contact-number">{{ theatre.SupportPhone }}</div>
      </div>
    </div>

    <div class="support-cultural-program-body">
      <div class="support-cultural-program-info">
        <div class="poster-wrapper">
          <img class="poster" :src="`${setting.donationEventImage}`" alt="" />
        </div>

        <div class="info-event--text">
          <div>
            <h1>{{ setting.donationEventTitle }}</h1>
          </div>
          <div>
            <p
              v-html="
                setting.donationEventDescr ||
                  'Мы благодарны каждому, кто поддержит кинотеатр'
              "
            ></p>
          </div>
        </div>
      </div>

      <div class="donations">
        <h2>Сумма поддержки</h2>
        <div class="step-box-inputs">
          <div class="variants-donation">
            <label
              v-for="(donationMoneySize,
              index) in setting.donationEventMoney.split(' ')"
              v-bind:key="index"
              @click="selectDonationSizes(donationMoneySize)"
            >
              {{ donationMoneySize }} {{ setting.currency }}
            </label>
          </div>
          <span class="and">или</span>
          <div class="input-wrapper">
            <input
              v-model="cart.donations"
              id="donations"
              @input="onChangeInputDonationSizes"
              placeholder="Введите сумму"
              type="number"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="support-cultural-program-footer">
      <div class="basket-step-forward">
        <div class="basket-btn" @click="goNext">
          <span class="btn-icon"></span>
          <span class="btn-label">Поддержать</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '@/types';

export default {
  name: 'SupportCulturalProgram',

  data() {
    return {
      donations: '',
    };
  },

  computed: {
    ...mapState(['setting', 'user', 'movie', 'cart', 'bar', 'theatre']),
  },

  methods: {
    log(msg) {
      console.log(msg);
    },

    onChangeInputDonationSizes(e) {
      this.$store.commit(types.SET_DONATION_SIZE, e.target.value);
    },

    selectDonationSizes(donationSize) {
      this.$store.commit(types.SET_DONATION_SIZE, donationSize);
    },

    goNext() {
      this.$router.push(
        `/${this.$route.params.theatreId}/${this.$route.params.session}/buy`,
      );
    },
  },
};
</script>

<style src='./SupportCulturalProgram.scss' lang="scss"></style>
